module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon25.2fb6b1f0.png";